// @ts-nocheck
export const EnvKeys = {
  API_IMPAIRMENT_URL: process.env.REACT_APP_IMPAIRMENT_API,
  API_URL: process.env.REACT_APP_API_URL,
  NEDU_WRAPPER_API: process.env.REACT_APP_NEDU_WRAPPER_API,
  EDR_API_BASEURL: process.env.REACT_APP_EDR_API_BASEURL,
  FINERACT_EXTERNAL_API_URL: process.env.REACT_APP_FINERACT_EXTERNAL_API_URL,
  LEADS_GENERATION_API: process.env.REACT_APP_LEADS_GENERATION_API,
  CDL_API_URL: process.env.REACT_APP_CDL_API_URL,
  SESSION_TIMEOUT: process.env.REACT_APP_SESSION_TIMEOUT,
  CDL_SEQUEST_API_URL: process.env.REACT_APP_CDL_SEQUEST_API_URL,
  FLUTTERWAVE_CHECKOUT_JS: process.env.REACT_APP_FLUTTERWAVE_CHECKOUT_JS,
  FLUTTERWAVE_PUBLIC_KEY: process.env.REACT_APP_FLUTTERWAVE_PUBLIC_KEY,
  PAYSTACK_CHECKOUT_JS: process.env.REACT_APP_PAYSTACK_CHECKOUT_JS,
  PAYSTACK_PUBLIC_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
  SEERBIT_CHECKOUT_JS: process.env.REACT_APP_SEERBIT_CHECKOUT_JS,
  SEERBIT_PUBLIC_KEY: process.env.REACT_APP_SEERBIT_PUBLIC_KEY,
  NX360_WRAPPER_API: process.env.REACT_APP_NX360_WRAPPER_API,
  NX360_WRAPPER_API_KEY: process.env.REACT_APP_NX360_WRAPPER_API_KEY,
  NX360_EDR_WRAPPER_API: process.env.REACT_APP_NX360_EDR_WRAPPER_API,
  NX360_EDR_WRAPPER_API_KEY: process.env.REACT_APP_NX360_EDR_WRAPPER_API_KEY,
  NX360_WRAPPER_OPEN_API_KEY: process.env.REACT_APP_NX360_WRAPPER_OPEN_API_KEY,
  NX360_HOOK_API_URL: process.env.REACT_APP_NX360_HOOK_API_URL,
  REMITA_CHECKOUT_JS: process.env.REACT_APP_REMITA_CHECKOUT_JS,
  REMITA_PUBLIC_KEY: process.env.REACT_APP_REMITA_PUBLIC_KEY,
  NX360_MAMBU_API: process.env.REACT_APP_NX360_MAMBU_API,
  NX360_MAMBU_API_KEY: process.env.REACT_APP_NX360_MAMBU_API_KEY,
  FINERACT_PUBLIC_API_SCHEME: process.env.REACT_APP_FINERACT_PUBLIC_API_SCHEME,
  FINERACT_PUBLIC_API_KEY: process.env.REACT_APP_FINERACT_PUBLIC_API_KEY,
  FINERACT_PUBLIC_API_KEY_HASHING:
    process.env.REACT_APP_FINERACT_PUBLIC_API_KEY_HASHING,
  FINERACT_EXTERNAL_API_KEY: process.env.REACT_APP_FINERACT_EXTERNAL_API_KEY,
  LEADS_GENERATION_API_KEY: process.env.REACT_APP_LEADS_GENERATION_API_KEY,
  API_URL_BASE_PATH: process.env.REACT_APP_API_URL_BASE_PATH,
  CDL_PAY_GTB_ZENITH_NO_MANDATE_PRODUCT_IDS:
    process.env.REACT_APP_CDL_PAY_GTB_ZENITH_NO_MANDATE_PRODUCT_IDS,
  LAF_OTP_CHANNEL_ID: process.env.REACT_APP_LAF_OTP_CHANNEL_ID,
  CURRENT_APP_VERSION: process.env.REACT_APP_CURRENT_APP_VERSION,
  REACT_APP_NIP_SUPPORT_API_URL: process.env.REACT_APP_NIP_SUPPORT_API_URL,
  REACT_APP_NIP_SUPPORT_API_KEY: process.env.REACT_APP_NIP_SUPPORT_API_KEY,
  REACT_APP_ZEUS_TEST_BASE_URI_API:
    process.env.REACT_APP_ZEUS_TEST_BASE_URI_API,
  REACT_APP_ZEUS_TEST_BASE_URI_API_KEY:
    process.env.REACT_APP_ZEUS_TEST_BASE_URI_API_KEY,
  REACT_APP_PAY_SYNC_API_URL: process.env.REACT_APP_PAY_SYNC_API_URL,
  REACT_APP_PAY_SYNC_API_KEY: process.env.REACT_APP_PAY_SYNC_API_KEY,
  REACT_APP_ZEUS_BASE_URI_API: process.env.REACT_APP_ZEUS_BASE_URI_API,
  REACT_APP_ZEUS_BASE_URI_API_KEY: process.env.REACT_APP_ZEUS_BASE_URI_API_KEY,
  REACT_APP_OUTWARD_TRANSACTION_API_URL:
    process.env.REACT_APP_OUTWARD_TRANSACTION_API_URL,
  REACT_APP_LOANS_BETA_API: process.env.REACT_APP_LOANS_BETA_API,
  REACT_APP_CBA: process.env.REACT_APP_CBA,
};
